import React from 'react';
import { Link } from 'react-router-dom';
import LazyComponent from '../components/common/LazyComponent';
import { useDemo } from '../context/DemoContext';

// Lazily load components
const Place = React.lazy(() => import('../components/Place'));
const Items = React.lazy(() => import('../components/Items'));
const Payment = React.lazy(() => import('../components/payment/payment'));

interface OrderViewProps {
  orderId: string | number;
  currentURL: string;
  userData: any;
}

/**
 * View component for active orders
 */
const OrderView: React.FC<OrderViewProps> = ({ orderId, userData }) => {
  const isDemo = useDemo();

  return (
    <div className={isDemo ? "demo-with-banner" : undefined}>
      {isDemo ? (
        <div className="demo-banner">
          <span>Demo. Nothing is charged.</span>
          <Link to="/">back to the site</Link>
        </div>
      ) : null}
      <div className="container mt-3">
        <LazyComponent>
          <Place oID={String(orderId)} />
        </LazyComponent>

        <LazyComponent>
          <Items oID={String(orderId)} />
        </LazyComponent>

        <LazyComponent>
          <Payment oID={String(orderId)} clientData={userData} />
        </LazyComponent>
      </div>
    </div>
  );
};

export default OrderView;
